import { createContext } from 'react'

import { injectIntl, IntlShape, WrappedComponentProps } from 'react-intl'

interface IInternationalizationContext {
  intl: IntlShape
}

export const InternationalizationContext = createContext({} as IInternationalizationContext)

type InternationalizationProviderProps = { children: React.ReactNode } & WrappedComponentProps

const InternationalizationProvider: React.FC<InternationalizationProviderProps> = ({
  children,
  intl,
}) => {
  return (
    <InternationalizationContext.Provider value={{ intl }}>
      {children}
    </InternationalizationContext.Provider>
  )
}

export default injectIntl(InternationalizationProvider)
